import dayjs, { Dayjs } from 'dayjs';

import tz from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(tz);

export const convertToMS = (
  time: number | string | Dayjs,
  startOrEnd?: 'start' | 'end'
): number => {
  if (!time) {
    return 0;
  } else if (typeof time === 'string' && startOrEnd && startOrEnd === 'start') {
    return dayjs(time).startOf('day').valueOf();
  } else if (typeof time === 'string' && startOrEnd && startOrEnd === 'end') {
    return dayjs(time).endOf('day').valueOf();
  } else if (typeof time === 'string') {
    return dayjs(time).valueOf();
  } else if (typeof time === 'object') {
    return time.valueOf();
  }

  return time > 9999999999 ? time : time * 1000;
};

export const convertToTimezonedMS = (
  time: number | string | Dayjs,
  timezone: string,
  startOrEnd?: 'start' | 'end'
): number => {
  if (!time) {
    return 0;
  } else if (typeof time === 'string' && startOrEnd && startOrEnd === 'start') {
    return dayjs.tz(time, timezone).startOf('day').valueOf();
  } else if (typeof time === 'string' && startOrEnd && startOrEnd === 'end') {
    return dayjs.tz(time, timezone).endOf('day').valueOf();
  } else if (typeof time === 'string') {
    return dayjs.tz(time, timezone).valueOf();
  } else if (typeof time === 'object') {
    return time.valueOf();
  }

  return time > 9999999999 ? time : time * 1000;
};

/**
 * Normalize an issued date (string | number | Dayjs | null/undefined)
 * to clinic start-of-day epoch milliseconds using the provided timezone.
 * - Missing value -> now at clinic start-of-day
 * - String -> clinic start-of-day for that date
 * - Number -> interpret as ms, shift to clinic tz, take start-of-day
 * - Dayjs -> shift to clinic tz, take start-of-day
 */
export const normalizeIssuedDateMs = (
  value: string | number | Dayjs | null | undefined,
  timezone: string
): number => {
  if (value == null) {
    return dayjs().tz(timezone).startOf('day').valueOf();
  }

  if (typeof value === 'string') {
    return convertToTimezonedMS(value, timezone, 'start');
  }

  if (typeof value === 'number') {
    return convertToTimezonedMS(dayjs(value).tz(timezone).startOf('day'), timezone);
  }

  // Dayjs
  return convertToTimezonedMS(value.tz(timezone).startOf('day'), timezone);
};
